module.exports = __webpack_public_path__ + "img/15-SMS.92e9a4f4.jpg";